import { createGlobalStyle } from 'styled-components'
// All fonts are found in assets/fonts/milliard, please add them below as per your needs
import MilliardBoldOtf from 'assets/fonts/milliard/MilliardBold.otf'
import MilliardBoldItalicOtf from 'assets/fonts/milliard/MilliardBoldItalic.otf'
import MilliardSemiBoldOtf from 'assets/fonts/milliard/MilliardSemiBold.otf'
import MilliardSemiBoldItalicOtf from 'assets/fonts/milliard/MilliardSemiBoldItalic.otf'
import MilliardBookOtf from 'assets/fonts/milliard/MilliardBook.otf'
import MilliardBookItalicOtf from 'assets/fonts/milliard/MilliardBookItalic.otf'

export const Fonts = createGlobalStyle`

/* 700 - bold */
@font-face {
  font-family: 'Milliard';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${MilliardBoldOtf}) format('opentype');
}

@font-face {
  font-family: 'Milliard';
  font-style: italic;
  font-weight: 700;
  font-display: swap;
  src: url(${MilliardBoldItalicOtf}) format('opentype');
}

/* 600 - medium */
@font-face {
  font-family: 'Milliard';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(${MilliardSemiBoldOtf}) format('opentype');
}

@font-face {
  font-family: 'Milliard';
  font-style: italic;
  font-weight: 600;
  font-display: swap;
  src: url(${MilliardSemiBoldItalicOtf}) format('opentype');
}

/* 400 - normal */
@font-face {
  font-family: 'Milliard';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${MilliardBookOtf}) format('opentype');
}

@font-face {
  font-family: 'Milliard';
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: url(${MilliardBookItalicOtf}) format('opentype');
}
`
